export default "__VITE_ASSET__BLaEb7jr__"